import { Component } from '@angular/core';
import { ReasonCategoryNewComponent } from './reason-category-new.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, CancelReasonCategoryService, UserService } from '../_services';
import { FormBuilder } from '@angular/forms';
import { ReasonCategory } from '../_models';
import { takeUntil } from 'rxjs/operators';

@Component({
  moduleId: module.id.toString(),
  selector: 'reason-category-edit',
  templateUrl: './reason-category-edit.component.html'
})
export class ReasonCategoryEditComponent extends ReasonCategoryNewComponent {

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected cancelReasonCategoriesService: CancelReasonCategoryService,
    protected userService: UserService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder
  ) {
    super(router, location, route, cancelReasonCategoriesService, userService, alertService, formBuilder);
    this.isNew = false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.loading = true;
    this.data$.pipe(takeUntil(this.destroy$)).subscribe((data: ReasonCategory) => {
      if (data) {
        this.loading = false;
        this.reasonCategory = data;
        this.form.patchValue({
          name: data.name,
          is_global: data.is_global
        });
      }
    });
  }
}
